module.exports = __webpack_public_path__ + "img/wifiIcon.e98e60e1.svg";